import { FindUserBy, FindUserFilters } from '@app/shared/types/admin/common';

interface UseFindUserProps {
  searchParams: URLSearchParams;
  updateSearchParams: (updates: Partial<FindUserFilters>) => void;
}

export const useFindUser = ({ searchParams, updateSearchParams }: UseFindUserProps) => {
  const findUserBy = (searchParams.get('findUserBy') || FindUserBy.TELEGRAM_TAG) as FindUserBy;
  const findUserValue = searchParams.get('findUserValue') || '';

  const handleFindUserByChange = (value: FindUserBy) => {
    updateSearchParams({ findUserBy: value, findUserValue: '' });
  };

  const handleFindUserValueChange = (value: string) => {
    updateSearchParams({ findUserValue: value });
  };

  return { findUserBy, handleFindUserByChange, findUserValue, handleFindUserValueChange };
};
